<!-- Layout principal com formulário centralizado -->
<div class="verify-code-container" #verifyCodeContainer>
  <!-- Formulário de verificação de código centralizado -->
  <div class="verify-code-section">
    <div class="verify-code-form">
      <div class="system-title">
        <h1 class="title">Verificar Código</h1>
        <h2 class="system-name">Reno Inteligência</h2>
      </div>
      <p class="sub-title">Digite o código de verificação de 6 dígitos</p>
      <p class="description">Código enviado para: <strong>{{ user.email }}</strong></p>

      <nb-alert *ngIf="showMessages.error && errors?.length && !submitted" outline="danger" role="alert">
        <p class="alert-title"><b>Erro</b></p>
        <ul class="alert-message-list">
          <li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
        </ul>
      </nb-alert>

      <nb-alert *ngIf="showMessages.success && messages?.length && !submitted" outline="success" role="alert">
        <p class="alert-title"><b>Sucesso!</b></p>
        <ul class="alert-message-list">
          <li *ngFor="let message of messages" class="alert-message">{{ message }}</li>
        </ul>
      </nb-alert>

      <!-- Campos de código em quadrados separados -->
      <div class="code-input-section">
        <div class="code-inputs-container">
          <input 
            #codeInput1
            type="text"
            maxlength="1"
            class="code-input"
            [(ngModel)]="inputValues[0]"
            (input)="onCodeInput($event, 0)"
            (keydown)="onCodeKeydown($event, 0)"
            (paste)="onCodePaste($event)"
            [disabled]="submitted"
            autocomplete="off"
            inputmode="numeric"
            pattern="[0-9]"
          />
          <input 
            #codeInput2
            type="text"
            maxlength="1"
            class="code-input"
            [(ngModel)]="inputValues[1]"
            (input)="onCodeInput($event, 1)"
            (keydown)="onCodeKeydown($event, 1)"
            (paste)="onCodePaste($event)"
            [disabled]="submitted"
            autocomplete="off"
            inputmode="numeric"
            pattern="[0-9]"
          />
          <input 
            #codeInput3
            type="text"
            maxlength="1"
            class="code-input"
            [(ngModel)]="inputValues[2]"
            (input)="onCodeInput($event, 2)"
            (keydown)="onCodeKeydown($event, 2)"
            (paste)="onCodePaste($event)"
            [disabled]="submitted"
            autocomplete="off"
            inputmode="numeric"
            pattern="[0-9]"
          />
          <input 
            #codeInput4
            type="text"
            maxlength="1"
            class="code-input"
            [(ngModel)]="inputValues[3]"
            (input)="onCodeInput($event, 3)"
            (keydown)="onCodeKeydown($event, 3)"
            (paste)="onCodePaste($event)"
            [disabled]="submitted"
            autocomplete="off"
            inputmode="numeric"
            pattern="[0-9]"
          />
          <input 
            #codeInput5
            type="text"
            maxlength="1"
            class="code-input"
            [(ngModel)]="inputValues[4]"
            (input)="onCodeInput($event, 4)"
            (keydown)="onCodeKeydown($event, 4)"
            (paste)="onCodePaste($event)"
            [disabled]="submitted"
            autocomplete="off"
            inputmode="numeric"
            pattern="[0-9]"
          />
          <input 
            #codeInput6
            type="text"
            maxlength="1"
            class="code-input"
            [(ngModel)]="inputValues[5]"
            (input)="onCodeInput($event, 5)"
            (keydown)="onCodeKeydown($event, 5)"
            (paste)="onCodePaste($event)"
            [disabled]="submitted"
            autocomplete="off"
            inputmode="numeric"
            pattern="[0-9]"
          />
        </div>
        
        <p class="code-instruction">Digite ou cole o código de 6 dígitos</p>
      </div>

      <!-- Botão de verificação -->
      <button 
        nbButton
        fullWidth
        status="primary"
        size="large"
        [disabled]="submitted || !isCodeComplete()"
        [class.btn-pulse]="submitted"
        (click)="verifyCode()"
        class="verify-btn">
        {{ submitted ? 'Verificando...' : 'Verificar Código' }}
      </button>

      <!-- Botões de navegação -->
      <div class="navigation-buttons">
        <button nbButton
                ghost
                status="basic"
                size="medium"
                (click)="resendCode()"
                [disabled]="submitted"
                class="resend-code-btn">
          <nb-icon icon="refresh-outline" pack="eva"></nb-icon>
          Reenviar Código
        </button>

        

        <button nbButton
                ghost
                status="basic"
                size="medium"
                (click)="goBackToLogin()"
                class="login-btn">
          <nb-icon icon="log-in-outline" pack="eva"></nb-icon>
          Ir para Login
        </button>
      </div>

      <!-- Informações adicionais -->
      <div class="additional-info">
        <p class="info-text">
          <nb-icon icon="info-outline" status="info"></nb-icon>
          <span>O código de verificação foi enviado para o e-mail cadastrado em sua conta.</span>
        </p>
        <p class="info-text">
          <nb-icon icon="clock-outline" status="warning"></nb-icon>
          <span>O código expira em 5 minutos por questões de segurança.</span>
        </p>
        <p class="info-text">
          <nb-icon icon="shield-outline" status="success"></nb-icon>
          <span>Não compartilhe este código com ninguém.</span>
        </p>
      </div>
    </div>
  </div>
</div>
